"use strict";

const MuniPopup = function () {
  var renderInspectionHistory = function (data, assetType, assetId, canCreateRoutineInspection) {
    var html = nunjucks.render("popups/history/muniInspectionHistory.njk", {
      assessments: data,
      assetType,
      assetId,
      canCreateRoutineInspection,
      permissions: {
        canDeleteInspections: UserRoles.getRolePermissionForUser("canDeleteInspections"),
      },
    });
    $(".popup-history-pane").html(html);
  };

  var bindListeners = function ($element, invalidateLayerDataFunction) {
    $element.off("click", ".download-report", onDownloadReport);
    $element.on("click", ".download-report", onDownloadReport);

    $element.off("click", ".edit-inspection", onEditInspection);
    $element.on("click", ".edit-inspection", onEditInspection);

    $element.off("click", ".delete-inspection");
    $element.on("click", ".delete-inspection", function () {
      onDeleteInspection.call(this, invalidateLayerDataFunction);
    });

    $element.off("click", ".open-hard-asset-inventory");
    $element.on(
      "click",
      ".open-hard-asset-inventory",
      HardAssetInventoryModalController.onOpenInventoryClick,
    );
  };

  var onEditInspection = function () {
    editHistory($(this).closest("tr").data());
  };

  var editHistory = function (tableRowData) {
    const id = tableRowData.id;
    const assetType = tableRowData.assetType;
    const assetId = tableRowData.assetId;

    Analytics.sendPopupEvent("edit_inspection", assetType);
    UrlRoutes.navigate(InspectionUrl.getForCurrentView(assetType, assetId, id));
  };

  var onDownloadReport = async function () {
    const $row = $(this).closest("tr");
    const id = $row.data("id");
    const assetType = $row.data("assetType");
    Analytics.sendPopupEvent("download_report", assetType);
    await ApiCalls.downloadMuniInspectionPdf(id, assetType);
  };

  var onDeleteInspection = async function (invalidateLayerDataFunction) {
    const $row = $(this).closest("tr");
    const id = $row.data("id");
    const assetType = $row.data("assetType");

    MessageModal.showDeleteRecordModal(async function () {
      await ApiCalls.deleteMuniInspection(id, assetType);
      $row.remove();
      invalidateLayerDataFunction();
      Analytics.sendPopupEvent("delete_inspection", assetType);
    });
  };

  return {
    renderInspectionHistory,
    bindListeners,
    editHistory,
  };
};

module.exports = MuniPopup();

const Analytics = require("../general/analytics");
const ApiCalls = require("../apiCalls");
const MessageModal = require("../modals/messageModal");
const UserRoles = require("../login/userRoles");
const HardAssetInventoryModalController = require("./hardAssetInventoryModalController");
const InspectionUrl = require("../routes/2nform/inspectionUrl");
const UrlRoutes = require("../routes/urlRoutes");
